// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__x8PX8","footer":"ReportModalFilter_footer__2Prjm"};